class CartCountBadge extends HTMLElement {
  connectedCallback() {
    this.badge = this.querySelector(".cart-count-badge");

    if (!this.badge) return;

    this.handleCartCountUpdate = this.handleCartCountUpdate.bind(this);

    window.addEventListener("cart:count-update", this.handleCartCountUpdate);
  }

  disconnectedCallback() {
    window.removeEventListener("cart:count-update", this.handleCartCountUpdate);
  }

  handleCartCountUpdate(event) {
    const { count } = event.detail;
    this.updateCount(count);
  }

  updateCount(count) {
    if (!this.badge) return;

    const currentCount = parseInt(this.badge.textContent) || 0;
    const newCount = parseInt(count) || 0;

    this.badge.textContent = newCount;

    if (newCount > 0) {
      this.badge.style.display = "";

      if (newCount > currentCount) {
        this.badge.classList.add("updating");

        setTimeout(() => {
          this.badge.classList.remove("updating");
        }, 600);
      }
    } else {
      this.badge.style.display = "none";
    }
  }
}

if (!customElements.get("cart-count-badge")) {
  customElements.define("cart-count-badge", CartCountBadge);
}
